import React from 'react';
import { trackEvent } from '../lib/metaPixel';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 relative overflow-hidden bg-teal-dark/20 border-t border-teal/20" data-id="element-79">
      {/* Subtle vignette/glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(31,58,52,0.4)_0%,rgba(11,13,12,1)_100%)]" data-id="element-80" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-81">
        <div data-id="element-82">
          <h2 className="font-serif text-[32px] sm:text-5xl md:text-6xl text-ivory mb-4 sm:mb-8 leading-[1.15] sm:leading-[1.1]" data-id="element-83">
            You Are Not Weak.
            <br data-id="element-84" />
            <span className="text-gold/90" data-id="element-85">Your Brain Was Overstimulated.</span>
          </h2>

          <p className="text-base sm:text-xl md:text-2xl text-ivory/80 font-light mb-7 sm:mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-86">
            UNHOOKED helps you understand what happened to your mind — and how
            to finally regain control.
          </p>

          <a href="https://vitalyforms.com/cart/50274454110428:1" onClick={() => trackEvent('AddToCart', {
          content_name: 'UNHOOKED Ebook',
          content_ids: ['50274454110428'],
          content_type: 'product',
          value: 14.99,
          currency: 'USD'
        })} className="inline-block w-full sm:w-auto bg-ivory text-charcoal hover:bg-white transition-all duration-300 px-8 sm:px-12 py-5 rounded-md font-medium text-base sm:text-lg tracking-wide mb-6 shadow-glow-gold hover:scale-[1.02]" data-id="element-87">
            Read UNHOOKED Now
          </a>

          <div className="text-[10px] sm:text-sm tracking-[0.12em] sm:tracking-[0.15em] uppercase text-ivory/50" data-id="element-88">
            Instant Digital Access • Private Purchase • 30-Day Guarantee
          </div>
        </div>
      </div>
    </section>;
}